import { ApplianceType } from 'common/api/v1/types'
import { useRoutes } from '../../../store'
import { GridItem, Paper } from '../../common/Form'
import DataSet from '../../common/DataSet'
import { Link } from '../../common/Link'
import type { RegionDetails } from '../../../api/region/api'

export interface MetaProps {
  regionDetails: RegionDetails
}

export const Meta = (props: MetaProps) => {
  const {
    region: { name, _externalText },
    appliancesTotal,
    videoScale,
    thumbScale,
  } = props.regionDetails
  const routes = useRoutes()
  const meta = {
    Name: name,
    Type: _externalText,
    'Appliances (Total)': (
      <Link to={routes.appliances({ regions: [name] })} underline="hover">
        {appliancesTotal}
      </Link>
    ),
    'Video Appliances': (
      <Link to={routes.appliances({ regions: [name], types: [ApplianceType.core] })} underline="hover">
        {videoScale.currentReplicas}
      </Link>
    ),
    'Thumb Appliances': (
      <Link to={routes.appliances({ regions: [name], types: [ApplianceType.thumb] })} underline="hover">
        {thumbScale.currentReplicas}
      </Link>
    ),
  }

  return (
    <Paper title="Metadata" collapsible actionsPane={[]}>
      <GridItem lg={12} xl={12}>
        <DataSet values={meta} />
      </GridItem>
    </Paper>
  )
}
